<template>
  <div class="user-container">
    <div class="school-panel flex-item">
      <span style="color: white; font-size: 18px;font-family:'微软雅黑;">
        {{
          $store.getters.currentOrganizationName != null
            ? $store.getters.currentOrganizationName
            : ""
        }}
      </span>
    </div>
    <div class="flex-item ico-btn" v-if="operationPermissions.alarm">
      <el-popover placement="bottom" title width="700" v-model="isShow" trigger="click">
        <div class="message_popover">
          <div class="head">
            <div class="message_head">
              <div class="title">告警信息</div>
              <div class="more">
                <el-tooltip
                  class="item details"
                  effect="dark"
                  content="更多"
                  placement="bottom"
                >
                  <i class="el-icon-more" @click="Jump"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="line"></div>
            <div class="flex-box">
              <div class="message_head_warp">
                <div>
                  <span class="total_all" style="padding-right: 8px">全部</span>
                  <span class="total_text">{{ alarmObj.Total }}</span>
                </div>
                <li class="total_line">|</li>
                <div style="margin: 0 30px">
                  <span class="circular"></span>
                  <span class="people">告警人数：</span>
                  <span class="text text_num" style="color: #d43c3c">{{
                    alarmObj.AlarmUserNum
                  }}</span>
                </div>
                <div>
                  <span class="circular" style="background: #ff9824"></span>
                  <span class="people">告警量表数：</span>
                  <span class="text text_num" style="color: #ff9824">{{
                    alarmObj.AlarmScaleNum
                  }}</span>
                </div>
              </div>
              <div class="all_read" @click="allRead">全部已读</div>
            </div>
          </div>
          <table class="tab">
            <tr>
              <th>告警程度</th>
              <th>告警人员</th>
              <th>告警量表</th>
              <th style="text-align: center">操作</th>
            </tr>
            <tr v-for="(item, index) in alarmObj.AlarmList" :key="index">
              <td width="140px">
                <span
                  v-if="item.severity_description != ''"
                  class="alarm_severity"
                  :style="{
                    background: $LYCom.GetMMPTDegreeColor(
                      item.severity,
                      item.severity_description
                    ),
                  }"
                  >{{ item.severity_description }}</span
                >
              </td>
              <td width="100px">{{ item.user_name }}</td>
              <td width="250px">{{ item.scale_name }}</td>

              <td class="operation" width="200px" style="text-align: center">
                <span @click="handleDetailReport(item)">查看报告</span>
                <span @click="handleAnswerRecord(item)">答题情况</span>
                <span @click="ignoreAlarm(item.alarm_id)">已阅</span>
                <!-- <span @click="solveAlarm(item)">解决</span> -->
              </td>
            </tr>
          </table>
        </div>
        <div class="message_warp" slot="reference">
          <span class="message_number" v-if="isMessageShow && alarmObj.Total != 0">{{
            alarmObj.Total
          }}</span>
          <i class="el-icon-message-solid icon-font"></i>
        </div>
      </el-popover>
    </div>
    <div class="flex-item ico-btn">
      <el-dropdown>
        <span class="user-name">
          <i class="fa fa-user icon-font"></i>
          &nbsp;{{ this.$store.getters.name }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="handleEditPwd">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="loginOut">退出系统</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="loginout">
      <!-- <el-button  type="text"></el-button > -->
      <span style="margin-right: 10px" @click="toFullscreen">全屏</span>
      <span @click="loginOut">退出</span>
    </div>
    <!--用户修改密码-->
    <el-dialog title="修改密码" :visible.sync="editPwdDialogVisible" width="480px">
      <el-form
        :model="formPwd"
        :rules="editPwdFormRules"
        ref="ruleForm"
        label-width="80px"
      >
        <el-form-item label="当前密码" prop="currentPwd">
          <el-input v-model="formPwd.currentPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="formPwd.newPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input v-model="formPwd.confirmPwd" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editPwdDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editPwd">确定</el-button>
      </span>
    </el-dialog>
    <!-- 解决告警弹框 -->
    <el-dialog title="选择解决告警方式" :visible.sync="solveAlarmDialog" width="600px">
      <div>
        <el-form ref="form" :model="alarmForm" label-width="100px">
          <el-form-item label="解决方式">
            <el-select v-model="alarmForm.alarmMode" placeholder="请选择解决方式">
              <el-option label="心理访谈" :value="1"></el-option>
              <el-option label="心理测评" :value="2"></el-option>
              <el-option label="心理训练" :value="3"></el-option>
              <el-option label="心理课程学习" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="心理访谈类型" v-if="alarmForm.alarmMode == 1">
            <el-select v-model="coachType" placeholder="请选择心理访谈类型">
              <el-option label="抑郁访谈" :value="1"></el-option>
              <el-option label="焦虑访谈" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="solveAlarmDialog = false">取 消</el-button>
        <el-button type="primary" @click="currentAlarmMode">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看详细报告 -->
    <el-dialog
      title="查看详细报告"
      :visible.sync="detailReportDialog"
      width="1010px"
      v-if="detailReportDialog"
    >
      <DetailReport
        style="width: 965px"
        id="printDom"
        :mmpt_record_id="mmpt_record_id"
      ></DetailReport>
      <span slot="footer" class="dialog-footer">
        <el-button v-print="'#printDom'">打印</el-button>
        <el-button type="primary" @click="detailReportDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--查看答题情况-->
    <el-dialog
      title="答题记录"
      :visible.sync="detailAnswerRecord"
      width="50%;"
      class="test_list"
    >
      <TestList
        v-loading="answerLoading"
        element-loading-text="拼命加载中"
        v-if="detailAnswerRecord"
        :jsonData="scaleQusetionList"
        :questionrow="questionrow"
      ></TestList>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailAnswerRecord = false">取 消</el-button>
        <el-button type="primary" @click="detailAnswerRecord = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TestList from "@/components/TestList";
import DetailReport from "@/components/detailReport";
import screenfull from "screenfull"; //引入screenfull
export default {
  name: "UserBox",
  components: {
    TestList,
    DetailReport,
  },
  data() {
    return {
      coachType: 1,
      curIDCard: "",
      mmpt_record_id: 0,
      questionrow: {},
      detailAnswerRecord: false,
      detailReportDialog: false,
      scaleQusetionList: [],
      alarmForm: {
        alarmMode: 1,
        student_id: 0,
        alarm_id: 0,
      },
      currentSchool: null,
      operationPermissions: {
        alarm: false,
      },
      solveAlarmDialog: false,
      isShow: false,
      alarmObj: {},
      isMessageShow: true,
      editPwdDialogVisible: false,
      formPwd: {
        currentPwd: "",
        newPwd: "",
        confirmPwd: "",
      },
      editPwdFormRules: {
        currentPwd: [{ required: true, message: "请输入当前密码", trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPwd: [{ required: true, message: "请输入确认密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.initOperations();
    // 轮询告警信息
    if (this.operationPermissions.alarm) {
      this.PollAnsyCall(function (e) {});
      // 消息图标闪烁
      setInterval(() => {
        this.isMessageShow = !this.isMessageShow;
      }, 500);
    }
    let self = this;
    // setTimeout(function() {
    // self.currentSchool = self.$store.getters.currentSchool;
    // }, 5000);
  },
  methods: {
    // 全屏切换方法
    toFullscreen() {
      //不支持screenfull全屏，则打印错误
      if (!screenfull.isEnabled) {
        console.error("unEnabled");
        return;
      }
      screenfull.toggle();
    },
    // 全部已读告警信息
    allRead() {
      this.$confirm("确认阅读全部告警信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let self = this;
          LYCom.AsynCallBiz(
            (e) => {
              if (e.err) {
                self.$message.error("操作失败！");
              } else {
                if (e.rtnObj) {
                  self.$message.success("操作成功！");
                  self.getAlarmList();
                }
              }
            },
            "MMPTBiz.AllIgnoreAlarm",
            LYCom.GetToken()
          );
        })
        .catch(() => {});
    },
    // 查看某个量表报告
    handleDetailReport(row) {
      // 获取测评id
      this.mmpt_record_id = 0;
      this.mmpt_record_id = row.mmpt_record_id;
      if (!row.mmpt_record_id) {
        return this.$message.info("量表未完成！");
      }
      this.detailReportDialog = true;
    },
    //获取答题记录
    handleAnswerRecord(row) {
      this.questionrow = {};
      this.detailAnswerRecord = true;
      this.questionrow = row;
      let self = this;
      this.answerLoading = true;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.rtnObj) {
            // 获取量表试题列表
            self.scaleQusetionList = e.rtnObj;
          }
          self.answerLoading = false;
        },
        "MMPTBiz.GetAnswerRecordById",
        LYCom.GetToken(),
        row.mmpt_record_id
      );
    },
    // 初始化操作权限
    initOperations() {
      this.operationPermissions.alarm = this.$permission.HasOperationPermission(
        "/psychologyEvaluation/warning",
        "实时告警"
      );
    },

    // 忽略告警
    ignoreAlarm(alarm_id) {
      this.$confirm("确认阅读该条告警信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let self = this;
          LYCom.AsynCallBiz(
            (e) => {
              if (e.err) {
                self.$message.error("操作失败！");
              } else {
                if (e.rtnObj) {
                  self.$message.success("操作成功！");
                  self.getAlarmList();
                }
              }
            },
            "MMPTBiz.IgnoreAlarm",
            LYCom.GetToken(),
            alarm_id
          );
        })
        .catch(() => {});
    },
    // 重新获取告警列表
    getAlarmList() {
      let self = this;
      LYCom.AsynCallBiz(
        (e) => {
          if (e.err) {
            self.$message.error("获取告警列表失败！");
          } else {
            if (e.rtnObj) {
              self.alarmObj = e.rtnObj;
            }
          }
        },
        "MMPTBiz.GetAlarmListNow",
        LYCom.GetToken()
      );
    },
    // 解决告警
    solveAlarm(alarmInfo) {
      this.solveAlarmDialog = true;
      this.alarmForm.student_id = alarmInfo.student_id;
      this.alarmForm.alarm_id = alarmInfo.alarm_id;
      this.curIDCard = alarmInfo.idcard;
    },
    // 选择解决方式
    currentAlarmMode() {
      let alarmMode = this.alarmForm.alarmMode; // 解决方式 0：心理辅导；1：心理测评；2：心理训练；3：心理课程学习
      // 告警信息
      let alarmInfo = {
        solved_method: alarmMode,
        alarm_id: this.alarmForm.alarm_id,
        path: this.$route.path,
      };
      window.sessionStorage.setItem("alarmInfo", JSON.stringify(alarmInfo));
      if (alarmMode != 1) {
        this.$router.push({
          name: "addPsychologyTask",
          query: {
            student_id: this.alarmForm.student_id,
          },
        });
      } else {
        this.$router.push({
          name: "questionnaire",
          query: {
            student_id: this.alarmForm.student_id,
            coachType: this.coachType,
            idcard: this.curIDCard,
          },
        });
      }
      this.solveAlarmDialog = false;
    },

    // 更多跳转
    Jump() {
      this.isShow = false;
      if (this.$route.path != "/psychologyEvaluation/warning") {
        this.$router.push({
          name: "warning",
        });
      }
    },

    /**
     * 用户登出登录
     */
    loginOut() {
      this.$confirm("确认退出系统？", "提示")
        .then((_) => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        })
        .catch((_) => {});
    },
    loginOutSchool() {
      //获取角色列表
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("退出学校失败！" + e.err);
          } else {
            if (e.rtnObj) {
              self.$store.commit("SET_CURRENTSCHOOL", null);
              self.$router.push("/home");
            } else {
              self.$message.error("退出学校失败！");
            }
          }
        },
        "SysMgrBiz.OutSchool",
        sessionStorage.getItem("token")
      );
    },
    /**
     * 用户修改密码点击事件
     */
    handleEditPwd() {
      this.formPwd = {
        currentPwd: "",
        newPwd: "",
        confirmPwd: "",
      };
      this.editPwdDialogVisible = true;
    },
    /**
     * 修改用户密码
     */
    editPwd() {
      if (this.formPwd.newPwd != this.formPwd.confirmPwd) {
        this.$message.warning("新密码与确认密码不一致");
        return false;
      }

      try {
        let result = LYCom.CallBiz(
          "SysMgrBiz",
          "UpdatePwd",
          LYCom.GetToken(),
          this.formPwd.currentPwd,
          this.formPwd.newPwd,
          this.formPwd.confirmPwd
        );
        if (result.success) {
          this.$message.success("修改密码成功");
          this.editPwdDialogVisible = false;
        } else {
          this.$message.warning(result.errmsg);
        }
      } catch (e) {
        this.$message.error("修改密码错误，" + e);
      }
    },
    PollAnsyCall(onAsynCallBack) {
      if (true) {
      }
      let self = this;
      let data = { arg0: LYCom.GetToken() };
      LYCom.FormatAjaxArg(data);
      $.ajax({
        url: LYCom.CallBizCfg.SvrRoot + "MMPTBiz.GetAlarmListNow",
        type: "POST",
        async: true,
        data: data,
        processData: LYCom.CallBizCfg.ProcessData,
        timeout: LYCom.CallBizCfg.Timeout,
        dataType: "json",
        success: function (data, textStatus, jqXHR) {
          onAsynCallBack({ rtnObj: data });
          self.alarmObj = data;
          setTimeout(function () {
            self.PollAnsyCall(onAsynCallBack);
          }, 5000);
        },
        error: function (xhr, textStatus) {
          if (textStatus == "timeout") {
            onAsynCallBack({ err: "调用超时!" });
          } else {
            if (xhr.responseText == "token失效") {
              self
                .$confirm(
                  "你已被登出，可以取消继续留在该页面，或者重新登录",
                  "确定登出",
                  {
                    confirmButtonText: "重新登录",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                )
                .then(() => {
                  self.$store.dispatch("FedLogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                });
            } else {
              onAsynCallBack({ err: "BizSvrErr:" + xhr.responseText });
            }
          }
        },
      });
      LYCom.ResetCallBizCfg();
    },
  },
};
</script>
<style>
.el-badge__content {
  background-color: #c12323;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 10px !important;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: none;
}
</style>
<style scoped>
.user-container {
  display: flex;
  /*flex-direction: column;*/
  align-items: center;
  /*justify-content: flex-end;*/
  /*background-color: red;*/
  padding: 0 5px 0 0;
}

.flex-item {
  padding: 0 10px 0 5px;
}

.school-panel {
  /*padding-right: 40px;*/
  /*padding: 0 5px 0 0;*/
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
}

.icon-font {
  font-size: 24px;
  /*color: rgb(80, 134, 255);*/
}

.ico-btn {
  cursor: pointer;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ecf5ff;
  color: #091d7c;
}

.message_item {
  margin-top: 10px;
  margin-right: 10px;
  font-size: 10px;
}

.message_warp {
  position: relative;
  width: 30px;
}

.message_warp .message_number {
  position: absolute;
  left: 13px;
  top: -5px;
  padding: 0 6px;
  font-size: 10px;
  background: #c71616;
  border-radius: 10px;
}

.message_popover {
  padding: 0 10px 10px 10px;
}

.people {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-size: 14px;
  color: #687782;
}

.message_popover .head .more {
  cursor: pointer;
  font-size: 20px;
}

.message_popover .head .message_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.line {
  height: 1px;
  border-bottom: 1px solid #ddd;
  margin: 10px 0;
}

.total_line {
  padding: 0 20px;
  color: rgb(238, 238, 238);
  font-weight: 100;
  font-size: 24px;
}

.message_head_warp {
  display: flex;
  align-items: center;
}
.flex-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.all_read {
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: #01058a;
}

.message_popover .head .title {
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: #01058a;
}

.total_text {
  font-family: "\5FAE\8F6F\96C5\9ED1 Bold", "\5FAE\8F6F\96C5\9ED1";
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #006dba;
  margin-right: 28px;
}

.total_all {
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #a29faa;
}

.message_popover .head .message_head {
  display: flex;
  align-items: center;
}

.message_popover .head .more {
  color: rgb(184, 186, 192) !important;
}

.tab tr th {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #a29faa;
  line-height: 40px;
}

.tab tr td {
  line-height: 45px;
  border-bottom: 1px solid rgb(235, 235, 235);
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  color: #2d3037;
}

.operation span {
  margin: 0 5px;
  cursor: pointer;
  color: #409eff;
  font-weight: 400;
}

.circular {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 2px;
  background: #d43c3c;
}
.loginout {
  cursor: pointer;
  /* margin-left: 20px; */
}
.user-name {
  display: flex;
  align-items: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/UserBox.vue